/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrganizationToken.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/organization-token";

export class AutogenModelOrganizationToken<RowType extends ModelRow> extends Endpoint<RowType, RowOrganizationTokenFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOrganizationToken extends ModelRow<RowOrganizationTokenFields> {
	constructor(values?: Partial<RowOrganizationTokenFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOrganizationTokenFields {
	authorization_attempted: string;
	company_id: string;
	dat_org_auth_error: string;
	id: string;
	org_expiration_date: Date;
	organization_token: string;
	token_expiration_date: Date;
	vendor: string;
}

